// src/utils/unitConverter.js
// Mirror of labeldesigner-api/lib/unitConverter.js
// All label coordinates stored in mm; canvas renders in px.

export const SCREEN_PPI = 96

export const mmToInch  = (mm)   => mm / 25.4
export const inchToMm  = (inch) => inch * 25.4
export const mmToPx    = (mm)   => mm * (SCREEN_PPI / 25.4)
export const pxToMm    = (px)   => px / (SCREEN_PPI / 25.4)
export const mmToDots  = (mm, dpi)   => Math.round(mm * (dpi / 25.4))
export const inchToPx  = (inch) => inch * SCREEN_PPI
export const pxToInch  = (px)   => px  / SCREEN_PPI

/**
 * Snap a mm value to the nearest grid increment.
 */
export function snapToGrid(mm, gridSizeMm) {
  if (!gridSizeMm || gridSizeMm <= 0) return mm
  return Math.round(mm / gridSizeMm) * gridSizeMm
}

/**
 * Convert a value between units.
 * @param {number} value
 * @param {'mm'|'inch'|'px'} from
 * @param {'mm'|'inch'|'px'} to
 */
export function convert(value, from, to) {
  let mm
  switch (from) {
    case 'mm':   mm = value;            break
    case 'inch': mm = inchToMm(value);  break
    case 'px':   mm = pxToMm(value);    break
    default: throw new Error(`Unknown unit: ${from}`)
  }
  switch (to) {
    case 'mm':   return mm
    case 'inch': return mmToInch(mm)
    case 'px':   return mmToPx(mm)
    default: throw new Error(`Unknown unit: ${to}`)
  }
}

/**
 * Format a mm value for display, respecting the label's unit preference.
 */
export function formatUnit(mm, unit = 'mm', decimals = 2) {
  const val = unit === 'inch' ? mmToInch(mm) : mm
  return `${val.toFixed(decimals)} ${unit}`
}
